import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import { Helpers } from '../core/src/helpers';
import { fetchPrices, NO_PRICE } from '../product/product-actions';

const selectPrices = Helpers.memoize((prices, products, user) => {
    return products.reduce((r, p) => {
        let priceObj = Helpers.getProductPrice(p, prices);
        const { items } = priceObj;
        if (user && user.TierPriceMsg && priceObj.tierPrice) {
            priceObj.tierMsg = user.TierPriceMsg
        }
        //if product is a kit attach kit item prices (AS OF NOW HPSERVICES RETURNS UNDERLYING KIT ITEM PRICES WHEN YOU FETCH THE KIT PRICE)
        if (items && Object.keys(items).length > 0) {
            priceObj.items = Object.keys(items).reduce((r, key) => {
                let item = items[key];
                let itemPriceObj = Helpers.getProductPrice(item, prices);
                r[key] = { ...itemPriceObj, ...item };
                return r;
            }, {})
        }
        r[p.sku] = priceObj;
        return r;
    }, {});
}, (prices, products) => {
    return products.reduce((r, p) => {
        return r.concat(`${p.sku}-${p.sku in prices}`)
    }, ``)
});

/**
 * @typedef {Object} Product
 * @property {string} sku - product SKU
 * @property {string} itemId - legacy id of product used to fetch price
 * @property {string} catentryId - new id for fetching product price
 * @property {Array.<Product>} bundleComponents - array of bundle products that also need prices
 */

/**
 * @name usePricePrice
 * @param {Array.<Product>} products
 * @returns {object} - Product price hash map by sku
 */
export default function useProductPrice(products = []) {
    const dispatch = useDispatch();
    const prices = useSelector(state => state.productData.productInfo.productPrices);
    const user = useSelector(state => state.userData);

    useEffect(() => {
        let noPrice = products.filter(({ sku, itemId, catentryId, prdClass, product_class }) => {
            const priceFailure = prices[itemId || catentryId];
            const productType = prdClass || product_class;
            //when prices fai to fetch, we get no response back so we dont know the sku
            // which mean we need to check for fetch fail by itemId
            return !(productType in NO_PRICE) && !(sku in prices) && (!priceFailure || !priceFailure.priceFetchFailed)
        });
        if (noPrice.length > 0) {
            dispatch(fetchPrices(noPrice.map(p => p.itemId || p.catentryId)));
        }
    })

    return { prices: selectPrices(prices, products, user) }
}